module.exports = __webpack_public_path__ + "static/media/spotifydark.4340c498.png";